import { DEFAULT_LANGUAGE, DEFAULT_USER_SPECIFIC, IDB } from '@/core/db'

interface ParseSingleCellParams {
  tbl?: string
  col?: string
  row?: string | number
}

export function parseSingleCellValue(
  params: ParseSingleCellParams,
  dbClient?: IDB,
  language = DEFAULT_LANGUAGE,
  userSpecific = DEFAULT_USER_SPECIFIC,
  withColumnFormat = true
) {
  if (!dbClient) return

  let { tbl, col, row } = params
  if (!tbl || !col) return

  let inValidRowString = typeof row === 'string' && !row
  let inValidRowNumber = typeof row === 'number' && (isNaN(row) || row < 0)
  let inValidRow = inValidRowString || inValidRowNumber

  if (inValidRow) return

  const table = dbClient.tablesMap.get(tbl)
  if (!table) return

  let cell = table.GetCellData(col, Number(row), language, userSpecific)

  // fallback to default language
  if (!cell && language !== DEFAULT_LANGUAGE) {
    cell = table.GetCellData(col, Number(row), DEFAULT_LANGUAGE, userSpecific)
  }
  
  if (!cell) return

  return withColumnFormat ? cell.toString() : cell.value
}
